import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { StaffPostById } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import PostSettingsTab from "./tabs/PostSettingsTab";
import Spinner from "../../../../ui/Spinner/Spinner";
import { TbArrowLeft } from "react-icons/tb";

const StaffItem = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [currentPost, setCurrentPost] = useState<StaffPostById>();
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/posts/${id}`);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    doFetchItem();
  }, [id]);

  useEffect(() => {
    if (!response) {
      return;
    }
    setCurrentPost(response.data as unknown as StaffPostById);
    setLoading(false);
  }, [response]);

  return loading ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/positions"} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{t("positions")}</NavLink>
            <span className="text-2xl font-semibold">{t('editing_position')}</span>
          </div>
        </div>
        <Tabs defaultValue="settings" className="px-6">
          <TabsList className="w-full flex-none h-10 justify-between px-2 rounded">
            <div className="flex">
              <TabsTrigger value="settings">{t("settings")}</TabsTrigger>
            </div>
          </TabsList>
          <TabsContent value="settings">
            {currentPost ? <PostSettingsTab id={id} currentPost={currentPost} /> : ""}
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
};

export default StaffItem;
